export const isActiveLink = (url: string) => {
    if(!url) return false;
    // remove last slash to avoid false negative
    const lastSlash = /\/$/
    const browserUrl = window.location.pathname.replace(lastSlash, '')
    const linkUrl = url.replace(lastSlash, '')
    return browserUrl === linkUrl
}
